export default __webpack_public_path__ + "static/media/isabella_trybula.aca36a96.jpeg";